import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CollapseTrigger({ open, controls, variant = 'outlined', className, children, ...buttonProps }) {
    return (_jsxs("button", { ...buttonProps, type: "button", className: [
            'animated-collapse-trigger d-flex align-items-center justify-content-between w-100 border-0 bg-transparent text-dark text-left cursor-pointer',
            className,
            !open && 'collapsed',
        ]
            .filter(Boolean)
            .join(' '), "aria-expanded": open, "aria-controls": controls, children: [_jsx("span", { className: "mr-3", children: children }), _jsx("span", { className: [
                    'animated-collapse-chevron collapse-item-with-circle flex-none',
                    variant === 'filled' && 'circle-with-background small-circle bg-white',
                ]
                    .filter(Boolean)
                    .join(' '), "aria-hidden": "true", children: _jsx("i", { className: "nbw-icon collapse-item-arrow font-size-small nbw-icon-chevron-up" }) })] }));
}
